import { hexToRgb, warningColor, backgroundColor, orangeLabelColor } from 'assets/jss/material-dashboard-pro-react';

const accordionContentStyle = (theme) => ({
	noteContent: {
		backgroundColor: `rgba(${hexToRgb(warningColor[0])}, 0.1)`,
	},
	bottomRow: {
		height: 'auto!important',
		paddingTop: '16px',
		paddingBottom: '16px',
		'& > div > a': {
			marginTop: '8px',
			display: 'inline-block',
		},
		[theme.breakpoints.down('sm')]: {
			flexDirection: 'row!important',
			'& > div': {
				paddingRight: '6px',
			},
		},
	},
	termsWrapper: {
		height: 'auto!important',
		paddingTop: '8px',
		paddingBottom: '16px',
		flexDirection: 'row!important',
		'& > div': {
			display: 'flex',
		},
		'& > div > a': {
			display: 'inline-block',
		},
		[theme.breakpoints.down('sm')]: {
			'& > div': {
				paddingRight: '6px',
			},
		},
	},
	additionalMargin: {
		'& > div > a': {
			marginLeft: 8,
		},
	},
	singleAccordionRow: {
		paddingLeft: '24px',
		paddingRight: '24px',
		height: '48px',
		borderBottom: `2px solid ${backgroundColor[0]}`,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		[theme.breakpoints.down('sm')]: {
			padding: '20px 16px',
			height: 'auto',
			alignItems: 'flex-start',
		},
	},
	singleAccordionRowSpaceEvenly: {
		justifyContent: 'space-evenly',
	},
	withoutBorder: {
		border: 'none',
	},
	vatClauseWrapper: {
		padding: '0 24px',
	},
	secondaryBrand: {
		color: orangeLabelColor,
		marginRight: '10px',
	},
	removeSpace: {
		justifyContent: 'left !important',
	},
});

export default accordionContentStyle;
